import React from 'react';
import { useFormatCurrency } from "../common/format-currency";

const CartSummary = ({ bundles, currency }) => {
  const { formatCurrency } = useFormatCurrency();
  // Calculate total
  const ticketItems = bundles.filter(bundle => bundle.cartQuantity > 0);
  const totalAmount = ticketItems.reduce((acc, bundle) => acc + (bundle.cartQuantity * bundle.amount), 0);

  if (ticketItems.length === 0) {
    return (
      <div className="cart-summary">
        <div className="empty-cart-message">
          Your cart is empty.
        </div>
      </div>
    );
  }

  return (
    <div className="cart-summary">
      <h2>Order Summary</h2>
      <div className="summary-items">
        {ticketItems.map((bundle) => (
          <div key={bundle.id} className="summary-item">
            <span className="summary-item-quantity">{bundle.cartQuantity} x</span>
            <span className="summary-item-name">{bundle.name}</span>
            <span className="summary-item-price">{formatCurrency(bundle.amount, currency)}</span>
          </div>
        ))}
      </div>
      <div className="summary-total">
        <span>Total:</span>
        <span>{formatCurrency(totalAmount, currency)}</span>
      </div>
    </div>
  );
};

export default CartSummary;
